export default __webpack_public_path__ + "static/media/trading-leaderboard.b0d8df27.svg";